var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{on:{"logout":_vm.logout}}),_vm._v(" "),_c('main',{staticClass:"relative bg-white"},[_c('nuxt')],1),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('cookie-statement')],1)}
var staticRenderFns = []

export { render, staticRenderFns }